import axios from 'axios';
import {
  MP_CF_API_BASE_URL,
} from './Constants';

const getBaseConfig = (idToken) => {
  const headers = {
    'idToken': idToken || '',
    'uid': localStorage.getItem('uid') || '',
    'Content-Type': 'application/json',
  };

  if (idToken) {
    headers['Authorization'] = `Bearer ${idToken}`;
  }

  return {
    baseURL: MP_CF_API_BASE_URL,
    headers,
  };
}

const creatRequest = (idToken, requestConfigs) => {
  return axios.create(getBaseConfig(idToken))(requestConfigs);
};

export default creatRequest;
